import React, { useState } from "react";
import "./PAMMActiveAccounts.css";
import { Eye, Edit, TrendingUp } from "lucide-react";

function PAMMActiveAccounts() {
  const [accounts] = useState([
    { id: 1, accountNo: "PAMM-001", clientName: "John Doe", balance: "$50,000", profit: "+$5,200", drawdown: "8.5%", status: "Active", manager: "Fund Manager A", startDate: "2025-01-10" },
    { id: 2, accountNo: "PAMM-002", clientName: "Jane Smith", balance: "$120,000", profit: "+$18,500", drawdown: "5.2%", status: "Active", manager: "Fund Manager B", startDate: "2025-02-15" },
    { id: 3, accountNo: "PAMM-003", clientName: "Mike Johnson", balance: "$35,000", profit: "+$2,100", drawdown: "12.3%", status: "Active", manager: "Fund Manager A", startDate: "2025-03-01" },
  ]);

  return (
    <div className="pamm-accounts-container">
      {/* Page Header */}
      <div className="page-header">
        <div className="header-left">
          <h1>Total PAMM Active Accounts</h1>
          <div className="header-bottom">
            <h2 className="view-all">View all active PAMM accounts</h2>
          </div>
        </div>
        <div className="header-right">
          <button className="btn create-btn">+ Create Account</button>
          <button className="btn orange">Export Data</button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-row">
        <div className="stat-card">
          <h3>Total Active Accounts</h3>
          <p className="stat-value">156</p>
        </div>
        <div className="stat-card">
          <h3>Total AUM</h3>
          <p className="stat-value">$2,450,000</p>
        </div>
        <div className="stat-card">
          <h3>Average Profit</h3>
          <p className="stat-value success">+12.5%</p>
        </div>
        <div className="stat-card">
          <h3>Average Drawdown</h3>
          <p className="stat-value warning">8.7%</p>
        </div>
      </div>

      {/* Filters Section */}
      <div className="filters">
        <input type="text" placeholder="Search by Account No, Client Name, Manager" />
        <button className="btn">Reset Filters</button>
      </div>

      {/* Filter Row */}
      <div className="filter-row">
        <select>
          <option>Status</option>
          <option>Active</option>
          <option>Suspended</option>
        </select>
        <select>
          <option>Fund Manager</option>
          <option>Fund Manager A</option>
          <option>Fund Manager B</option>
        </select>
        <input type="date" placeholder="Start Date" />
        <input type="date" placeholder="End Date" />
        <button className="btn">Export to Excel</button>
      </div>

      {/* Table */}
      <div className="table-container">
        <table className="pamm-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Account No</th>
              <th>Client Name</th>
              <th>Balance</th>
              <th>Profit/Loss</th>
              <th>Drawdown</th>
              <th>Fund Manager</th>
              <th>Status</th>
              <th>Start Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {accounts.map((account, index) => (
              <tr key={account.id}>
                <td>{index + 1}</td>
                <td>{account.accountNo}</td>
                <td>{account.clientName}</td>
                <td>{account.balance}</td>
                <td className="profit">{account.profit}</td>
                <td>{account.drawdown}</td>
                <td>{account.manager}</td>
                <td>
                  <span className="status success">{account.status}</span>
                </td>
                <td>{account.startDate}</td>
                <td>
                  <button className="icon-btn" title="View">
                    <Eye size={18} />
                  </button>
                  <button className="icon-btn" title="Edit">
                    <Edit size={18} />
                  </button>
                  <button className="icon-btn" title="Performance">
                    <TrendingUp size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>Copyright © 2025 <span className="brand">Trade Fx Online Solutions</span>. All rights reserved.</p>
        <span className="version">Version 2.0</span>
      </footer>
    </div>
  );
}

export default PAMMActiveAccounts;
